/**
 * Загружает внешний скрипт в head документа и возвращает функцию очистки.
 *
 * @param src - URL скрипта.
 * @param options - Опции загрузки (defer — отложить выполнение скрипта).
 * @returns Функция, удаляющая скрипт из документа.
 */
export const loadScript = (src: string, options?: { defer?: boolean }) => {
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = src;

  if (options?.defer) {
    script.defer = true;
  }

  document.head.appendChild(script);

  return () => script.remove();
};

/**
 * Загружает внешнюю таблицу стилей в head документа и возвращает функцию очистки.
 *
 * @param href - URL таблицы стилей.
 * @returns Функция, удаляющая таблицу стилей из документа.
 */
export const loadStylesheet = (href: string) => {
  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.href = href;

  document.head.appendChild(link);

  return () => link.remove();
};
